import React from 'react'
import styled, { css } from 'styled-components'

export const StyledComponent = styled(({has_main_page_nav, ...rest}) => <div {...rest} />)`
  align-items: center;
  display: flex;
  display: grid;
  column-gap: 10px;
  grid-template-areas: "logo promo user";
  grid-template-columns: auto minmax(0, 1fr) auto;
  height: 40px;
  justify-content: space-between;
  margin: auto;
  max-width: 915px;
  padding: 0 10px;
  width: 100%;

  @media (min-width: ${p => p.theme.mobileLargeSize}) {
    height: 60px;
  }

  ${p => p.has_main_page_nav && css`
    column-gap: 24px;
    grid-template-areas: "logo nav user";
    grid-template-columns: auto minmax(0, 1fr) auto;
    max-width: 1525px;

    @media (max-width: ${p.theme.mediaTriggerWidth}) {
      column-gap: 12px;
    }
  `}
`
const _PageHeader_Inner = (props) => <StyledComponent {...props} />
_PageHeader_Inner.propTypes = {}
_PageHeader_Inner.className = StyledComponent

export default _PageHeader_Inner
